/**
 * Where the eGK snapshot on a GKV Verordnung came from (#1508).
 *
 * Recorded because the two paths carry different authority. A `SCANNED` card is
 * a faithful transcription of the Muster-13 barcode; a `MANUAL` one is what a
 * Therapeut:in read off the sheet. Anlage 3a §125 Ziffer 5a (festgesetzt durch
 * Schiedsspruch 1 HE 22-20) even lifts the general Korrekturerlaubnis for the
 * barcoded form — *„es ist eine neue Verordnung auszustellen"*.
 *
 * ⚠ **It warns, it never locks.** We stay editable regardless: thevea allows
 * Versichertennummer, Status and Kostenträgerkennung to be changed
 * *„im Einvernehmen"* and omits the exception from its docs entirely, so market
 * parity beats strictness here. Write-protecting scanned card fields was
 * explicitly rejected in the #1240 session as too strict. Editing a scanned
 * field warns visibly, marks the case, and **saves**.
 *
 * ⚠ And the provenance survives that edit. A corrected scan is still a scan;
 * flipping it to `MANUAL` on the first typo would erase the only record of how
 * the card reached us. A caller who means "this is now hand-typed" has to say so.
 */
export var GkvInsuranceProvenance;
(function (GkvInsuranceProvenance) {
    /** Read off the Muster 13 PDF417 barcode. */
    GkvInsuranceProvenance["SCANNED"] = "scanned";
    /** Typed off the sheet by a Therapeut:in — also the case for a blank card. */
    GkvInsuranceProvenance["MANUAL"] = "manual";
})(GkvInsuranceProvenance || (GkvInsuranceProvenance = {}));
//# sourceMappingURL=gkv-insurance-provenance.enum.js.map